import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { SellerBadge } from '@fiverr-private/listings';
import { FederatedSeller, useSellerData, useLocalizationContext } from '@fiverr-private/seller_pages_toolbox';
import { Fade } from '@fiverr-private/transition';
import { Text, Typography } from '@fiverr-private/typography';
import { translateRoleTitle } from '../../../../utils/translateRoleTitle';
import { useSellerRole } from '../../../../hooks/useSellerRole';
import { useRoleVariation } from '../../../../hooks/useRoleVariation';
import { nameWrClass, nameWrWithImageClass } from '../styles.ve.css';

interface RoleHeadingProps {
    sellerRoleId?: string;
    withAvatar?: boolean;
}

export const RoleHeading: React.FC<RoleHeadingProps> = ({ sellerRoleId, withAvatar = false }) => {
    const { displayName } = useSellerData(selectSellerSlice);
    const sellerRole = useSellerRole(sellerRoleId);
    const roleVariation = useRoleVariation();
    const { forceRoundCurrencyFormatFromUSD } = useLocalizationContext();

    if (!sellerRole) {
        return null;
    }

    return (
        <Stack direction="column" gap="1" minHeight="60px">
            <Container
                className={classNames(nameWrClass, {
                    [nameWrWithImageClass]: withAvatar,
                })}
            >
                <Fade in={withAvatar} duration="moderate1">
                    <Stack gap="2" alignItems="center">
                        <Text color="bodySecondary">{displayName}</Text>
                        {sellerRole.pro && <SellerBadge badge={SellerBadge.BADGES.PRO} dataTestId={undefined} />}
                    </Stack>
                </Fade>
            </Container>
            <Typography as="h5" color="black">
                {translateRoleTitle(sellerRole, roleVariation[sellerRole.id])}
            </Typography>
            <Text>
                <I18n
                    k="seller_page_perseus.professions_page.sidebar.price"
                    params={{
                        price: forceRoundCurrencyFormatFromUSD(sellerRole.startingPrice as number),
                    }}
                />
            </Text>
        </Stack>
    );
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    isPro: seller.isPro,
    displayName: seller.user.profile.displayName,
});
